<template>
    <div class="footer-box">
        <div class="footer-container-box">
            <div class="footer-logo-box">
                <img src="../../public/images/logo1.png" />
            </div>
            <div class="footer-content-box">
                <ul>
                    <li v-for="(item,key) in navData" :key="key" >
                        <router-link :to="item.path">{{item.name}}</router-link>
                    </li>
                </ul>
                <div class="footer-content-address clearfix">
                    <div class="footer-address clearfix">
                        <p class="footer-icon-phone">0512-67570907</p>
                        <p class="footer-icon-tel">18626295227</p>
                        <p class="footer-icon-email">Email: <a href="mailto:shicha@163.com" target="_blank">shicha@163.com</a></p>
                    </div>
                    <p class="footer-icon-box clearfix">
                        <span class="footer-icon-address">中国苏州城北东路1088号银都商务广场3幢508</span>
                    </p>
                    <p class="footer-icon-box clearfix">
                        <span>Copyright © 2020 苏州时差设计制作有限公司</span>
                        <span>ALL Rights Reserved.</span>
                        <span>苏ICP备20044113号-1</span>
                    </p>
                </div>
            </div>
            <div class="footer-link-box">
                <div class="footer-link-hover">
                    <img src="../../public/images/footer/wechat.png">
                </div>
                <!-- <ul>
                    <li v-for="(item,key) in linkData" :key="key">
                        <a :href="item.link">
                            <img :src="item.url"/>
                        </a>
                        <div v-if="item.isToolShow" class="footer-link-hover">
                            <img src="../../public/images/footer/wechat.png">
                        </div>
                    </li>
                </ul> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            navData: [
                {
                    name: "首页",
                    path: "/",
                    index: 0,
                },
                {
                    name: "时差印象",
                    path: "/impress",
                    index: 1,
                },
                {
                    name: "精选案例",
                    path: "/case",
                    index: 2
                },
                // {
                //     name: "关于我们",
                //     path: "/about",
                //     index: 3,
                // },
                {
                    name: "时差动态",
                    path: "/news",
                    index: 4,
                },
                {
                    name: "招贤纳士",
                    path: "/like",
                    index: 4,
                }
            ],
            linkData: [
                // {
                //     url: require('../../public/images/footer/link1.png'),
                //     link: "https://weibo.com/"
                // },
                // {
                //     url: require('../../public/images/footer/link2.png'),
                //     link: "javascript:;",
                //     isToolShow: true
                // },
                // {
                //     url: require('../../public/images/footer/link3.png'),
                //     link: "mailto:zh@qq.com"
                // }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.footer-box{
    width: 100%;
    height: 200px;
    background: #333333;

    .footer-container-box {
        width: 1200px;
        margin: 0 auto;
        height: 140px;
        padding-top: 30px;
        color: #fff;
        display: flex;
        // justify-content: center;

        .footer-logo-box {
            width: 95px;
            border-right: 1px solid #585858;

            img {
                margin-top: -5px;
            }
        }

        .footer-content-box {
            padding-left: 40px;
            ul {
                display: flex;
                list-style: none;
                justify-content: space-between;
                padding: 0;
                li {
                    cursor: pointer;
                    border-right: 1px solid #fff;
                    padding-right: 35px;

                    &:last-child {
                        border: 0;
                    }
                    a {
                        font-size: 18px;
                        color: #fff;
                        text-decoration: none;
                    }

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
            .footer-content-address {
                font-size: 14px;
                // margin-top: 30px;
                .footer-address {
                    margin-bottom: 10px;
                    p {
                        float: left;
                        margin-right: 50px;
                        margin-bottom: 0;
                        background: left center no-repeat;
                        padding-left: 25px;
                    }

                    .footer-icon-phone {
                        background-image: url('../../public/images/footer/icon1.png');
                    }

                    .footer-icon-tel {
                        background-image: url('../../public/images/footer/icon2.png');
                    }

                    .footer-icon-email {
                        background-image: url('../../public/images/footer/icon4.png');
                        
                        a {
                            color: #fff;
                            text-decoration: none;
                        }
                    }
                }

                .footer-icon-box {
                    margin-bottom: 5px;
                    span {
                        float: left;
                        margin-right: 20px;

                        // &:last-child {
                        //     margin-left: 20px;
                        // }

                        &.footer-icon-address {
                            margin-left: 0;
                            background: url('../../public/images/footer/icon3.png') left center no-repeat;
                            padding-left: 25px;
                        }
                    }
                }
            }
        }

        .footer-link-box {
            flex: auto;

            .footer-link-hover {
                width: 120px;
                height: 120px;
                float: right;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
            // ul {
            //     list-style: none;
            //     padding: 0;
            //     display: flex;
            //     justify-content: flex-end;
            //     margin: 0;

            //     li {
            //         margin-left: 30px;
            //         position: relative;

            //         .footer-link-hover {
            //             width: 150px;
            //             height: 150px;
            //             position: absolute;
            //             bottom: 100%;
            //             left: -50px;
            //             transform: rotateX(90deg);
            //             transition: all 0.2s linear;
            //             transform-origin: bottom center;

            //             img {
            //                 width: 100%;
            //                 height: 100%;
            //             }
            //         }

            //         &:hover {
            //             .footer-link-hover {
            //                 transform: rotate(0);
            //             }
            //         }
            //     }
            // }
        }
    }
}
@media screen and (max-width: 1260px){
   .footer-box{
        .footer-container-box {
            width: auto; 
            margin: 0 20px;
        }
   } 
}
</style>